import $ from 'jquery';
import slick from 'slick-carousel';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';

class Carousel {
    constructor(target, settings) {
        this.carouselContainer = target;
        this.settings = settings || {
            mobileFirst: true,
            arrows: false,
            dots: true,
            centermode: false,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        arrows: true,
                        dots: true
                    }
                }
            ]
        };
    }

    init() {
        $(this.carouselContainer).slick(this.settings);

		this.initCarousels();
        this.carouselWidget();
        this.iconCarouselWidget();
        this.resetIframes();
        this.attachImgEvents();
        this.fadeinRegister();
    }

    initCarousels() {
        if ($('.carousel--big-ideas')) 
        {
        const bigIdeasLeftButton = $('.carousel--big-ideas .carousel-btn-left');
		const bigIdeasRightButton = $('.carousel--big-ideas .carousel-btn-right');
		const bigIdeasCarousel = $('.carousel--big-ideas.cards--grid')[0];
    
        this.checkForHorizontalOverflow(bigIdeasCarousel, bigIdeasLeftButton, bigIdeasRightButton);
        $(window).on('resize', () => this.checkForHorizontalOverflow(bigIdeasCarousel, bigIdeasLeftButton, bigIdeasRightButton));

		bigIdeasLeftButton.on('click', () => {
            const maxScrollX = this.getMaxScrollX(bigIdeasCarousel) + 20;
			const currentScrollX = bigIdeasCarousel.scrollLeft;
			const newScrollX = Math.max(currentScrollX - maxScrollX, 0);
			bigIdeasCarousel.scrollTo({
				left: newScrollX,
				behavior: 'smooth'
			});
		});

		bigIdeasRightButton.on('click', () => {
			const maxScrollX = this.getMaxScrollX(bigIdeasCarousel) + 20;
			const currentScrollX = bigIdeasCarousel.scrollLeft;
			const newScrollX = Math.min(currentScrollX + maxScrollX, bigIdeasCarousel.scrollWidth - bigIdeasCarousel.clientWidth);
			bigIdeasCarousel.scrollTo({
				left: newScrollX,
				behavior: 'smooth'
			});
		});
        } 
        if ($('.carousel--videos')) 
        {
            if ($('video')) 
            {
                // eslint-disable-next-line no-plusplus
                for (let i = 0; i < $('video').length; i++)
                {
                    $('video')[i].load();
                }
            }
        const videoLeftButton = $('.carousel--videos .carousel-btn-left');
		const videoRightButton = $('.carousel--videos .carousel-btn-right');
		const videoCarousel = $('.carousel--videos.cards--grid')[0];
    
            this.checkForHorizontalOverflow(videoCarousel, videoLeftButton, videoRightButton);
            $(window).on('resize', () => this.checkForHorizontalOverflow(videoCarousel, videoLeftButton, videoRightButton));

		videoLeftButton.on('click', () => {
            const maxScrollX = this.getMaxScrollX(videoCarousel) + 20;
			const currentScrollX = videoCarousel.scrollLeft;
			const newScrollX = Math.max(currentScrollX - maxScrollX, 0);
			videoCarousel.scrollTo({
				left: newScrollX,
				behavior: 'smooth'
			});
		});

		videoRightButton.on('click', () => {
			const maxScrollX = this.getMaxScrollX(videoCarousel) + 20;
			const currentScrollX = videoCarousel.scrollLeft;
			const newScrollX =  Math.min(currentScrollX + maxScrollX, videoCarousel.scrollWidth - videoCarousel.clientWidth);
			videoCarousel.scrollTo({
				left: newScrollX,
				behavior: 'smooth'
			});
		});
        } 

        if ($('.carousel--recipes')) 
        {
            const recipesLeftButton = $('.carousel--recipes .carousel-btn-left');
            const recipesRightButton = $('.carousel--recipes .carousel-btn-right');
            const recipesCarousel = $('.carousel--recipes.cards--grid')[0];
    
            this.checkForHorizontalOverflow(recipesCarousel, recipesLeftButton, recipesRightButton);
            $(window).on('resize', () => this.checkForHorizontalOverflow(recipesCarousel, recipesLeftButton, recipesRightButton));

		recipesLeftButton.on('click', () => {
            const maxScrollX = this.getMaxScrollX(recipesCarousel) + 20;
			const currentScrollX = recipesCarousel.scrollLeft;
			const newScrollX = Math.max(currentScrollX - maxScrollX, 0);
			recipesCarousel.scrollTo({
				left: newScrollX,
				behavior: 'smooth'
			});
		});

		recipesRightButton.on('click', () => {
			const maxScrollX = this.getMaxScrollX(recipesCarousel) + 20;
			const currentScrollX = recipesCarousel.scrollLeft;
			const newScrollX = Math.min(currentScrollX + maxScrollX, recipesCarousel.scrollWidth - recipesCarousel.clientWidth);
			recipesCarousel.scrollTo({
				left: newScrollX,
				behavior: 'smooth'
			});
		});
        } 
    }

    checkForHorizontalOverflow(carousel, leftButton, rightButton) {
        if (carousel && leftButton && rightButton) 
        {
            if (carousel.scrollWidth > carousel.clientWidth) {
                leftButton.css('display', 'flex');
                rightButton.css('display', 'flex');
            } else {
                leftButton.css('display', 'none');
                rightButton.css('display', 'none');  
            }
        }
    }

    getMaxScrollX(carousel) {
		if ($('.card.col-12')) {
			return $('.card.col-12.col-lg-3').width();
		} else {
			return carousel.scrollWidth - carousel.clientWidth;
		}
	}

    attachImgEvents() {
        let elements = $('.carousel-item');
        $(elements).on('click', (index, ele) => {
                setTimeout(() => {
                    let target = $('.carousel-img-modal .modal-img');
                    $(target).off('click');
                    $(target).on('click', (e) => {
                        $(e.currentTarget).toggleClass('big');
                    });
                }, 200);
        });
    }

    carouselWidget() {
		$('.slider-for').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
            fade: true,
            infinite: true,
			adaptiveHeight: true,
			asNavFor: '.slider-nav'
		});
		$('.slider-nav').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			asNavFor: '.slider-for',
			dots: false,
			infinite: true,
			arrows: true,
			focusOnSelect: true,
            mobileFirst: true,
            swipeToSlide: true,
		});

        $(window).on('load', () => {
            let carouselImgs = $('.carousel-item-img');
            $(carouselImgs).each((k, element) => {
                let elementModalId = $(element).data('modaal-content-source');
                let css = element.style.backgroundImage;
                let img = css.replace(/(?:^url\(["']?|["']?\)$)/g, '');
                let newImg = new Image();
                newImg.onload =  (e) => {
                   //console.log(this.naturalWidth); // This is the width you are looking for
                   //console.log(this.naturalHeight); // .. similarly the height.
                };
                newImg.src = img;
                if (newImg.width > newImg.height) {
                    if (!$(element).hasClass('is-landscape')) {
                        $(element).addClass('is-landscape');
                        $(elementModalId).find('.modal-img').addClass('is-landscape');
                    }
                } else if (newImg.width < newImg.height) {
                    if (!$(element).hasClass('is-landscape')) {
                        $(element).addClass('is-portrait');
                        $(elementModalId).find('.modal-img').addClass('is-portrait');
                    }
                }
            });
        });
	}

    iconCarouselWidget() {
        $('.slider-list').slick({
            arrows: true,
            fade: true,
            adaptiveHeight: true,
            responsive: [{
                breakpoint: 540,
                settings: {
                    slidesPerRow: 1,
                    rows: 1,
                }
            }]
        });
    }

// this method is used to reset iframes that are playing on carousels on slide change
    resetIframes() {
        $(this.carouselContainer).on('afterChange', (event, slick, currentSlide, nextSlide) => {
            this.resetIframe();
        });
        $('.slider-for').on('afterChange', (event, slick, currentSlide, nextSlide) => {
            this.resetIframe();
        });
        $('.slider-nav').on('afterChange', (event, slick, currentSlide, nextSlide) => {
            this.resetIframe();
        });
    }

    resetIframe() {
        $('.carousel iframe').each((k, v) => {
            let elSrc = $(v).attr('src');
            $(v).attr('src', elSrc);
        });
    } 

    fadeinRegister() {
		if (!window.Launchpad.pageBuilderEditMode) {
			const elements = $('.js-entry');
			const observer = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						this.handleLeftToRightAnimation();
						observer.unobserve(entry.target);
					}
				});
			});
			elements.each((i, e) => {
				observer.observe(e);
			});
		}
	}

    handleLeftToRightAnimation() {   
         setTimeout(() => {
			const anchorElements = document.querySelectorAll('.card-content-wrapper.ftl-animate');			

			// Add the 'fade-in-LtF' class to each element with a delay
			anchorElements.forEach((item, index) => {
				setTimeout(() => {
					item.classList.add('fade-in-LtF');
				}, index * 200); // Delay by 0.2 seconds per item
			});
		}, 1000);
    }
}

export default Carousel;

$(() => {
	const carousel = new Carousel();
	carousel.init();
});
